import { render } from "./TicketPriority.vue?vue&type=template&id=3982432c&scoped=true"
import script from "./TicketPriority.vue?vue&type=script&lang=js"
export * from "./TicketPriority.vue?vue&type=script&lang=js"

import "./TicketPriority.vue?vue&type=style&index=0&id=3982432c&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3982432c"]])

export default __exports__